
import CryptoJS from 'crypto-js';

export const encryptWithAES = (text) => {
  const passphrase = 'BSS';
  return CryptoJS.AES.encrypt(text, passphrase).toString().replace(/\+/g,'p1').replace(/\//g,'s1').replace(/=/g,'e1');
};

export const decryptWithAES = (ciphertext) => {
  const passphrase = 'BSS';
  ciphertext = ciphertext.toString().replace(/p1/g, '+' ).replace(/s1/g, '/').replace(/e1/g, '=');
  const bytes = CryptoJS.AES.decrypt(ciphertext, passphrase);
  const originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
};